import React, { useEffect, useState } from "react";
import { vendorServices } from "../../services/vendorServices";
import welcomeImage from "../../assests/images/welcome-right-img.png";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

function VendorWelcome() {
  const [isLoading, setIsLoading] = useState(false);
  const [isView, setIsView] = useState(false);
  const [vendorDetails, setVendorDetails] = useState({});
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  let navigate = useNavigate();

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getVendorDetails();
  }, []);


  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const getVendorDetails = (url) => {
    setIsLoading(true);
    vendorServices
      .getVendorDetails()
      .then(function (response) {
        if (response?.data?.success == true) {
          setVendorDetails(response?.data?.data);
          if (response?.data?.data?.vendor?.isOnboarded == true) {
            setIsView(false);
            navigate("/admin/welcome-onboard");
          } else {
            setIsView(true);
          }
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onOnboardingClick = (url) => {
    navigate("/admin/onboarding-from");
  };

  const onBiddingClick = (url) => {
    if (vendorDetails.vendor.isOnboarded == true) {
      navigate("/admin/dashboard");
    } else {
      navigate("/admin/onboarding-from");
    }
  };

  const handleButtonClick = () => {
    navigate("/admin/Engineering-Bidding-Rfq-Listing");
  };


  return (
    <div className="login-forms">
      {(isView == true) && <section class="welcome_outer">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="welcome_style pad_left">
                Welcome to Avaada
                <div class="lets_style">Let's get started! </div>
              </div>

              <div class="initiate-btn">
                <button onClick={onOnboardingClick}>
                  Initiate your Onboarding Process
                </button>
              </div>
              <p></p>
              {vendorDetails.vendor.isAllowedToBid == true &&
                <div class="participate-btn">
                  <button
                    onClick={() => {
                      handleButtonClick();
                    }}
                  >
                    Participate in Invited Bidding
                  </button>
                </div>
              }
            </div>
            <div className="col-md-6">
              <img src={welcomeImage} alt="" className="welcome-img-1" />
            </div>
          </div>
        </div>
      </section>}

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <Thankyou />
      <Onboardingstatus /> */}
    </div>
  );
}

export default VendorWelcome;
